import client from "../client/client";

class DistributionAlertService {
	getUnnotifiedAlert(projectId, cancelToken) {
		return client.get(`/distribution/alerts/projects/${projectId}/unnotified`, {
			config: { cancelToken },
		});
	}

	dismissAlert(projectId, cancelToken) {
		return client.post(`/distribution/alerts/projects/${projectId}/unnotified/dismiss`, {
			config: { cancelToken },
		});
	}
}

export default new DistributionAlertService();
